import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { parseCommaList } from '../lrsConfig';


export const CommaListField = ({ value, onChange, ...props }) => {
  const saved = (value || []).join(', ');
  const [text, setText] = useState(saved);
  const shown = parseCommaList(text).join(', ') === saved ? text : saved;
  return (
    <TextField
      fullWidth
      variant="standard"
      {...props}
      value={shown}
      onChange={(e) => {
        setText(e.target.value);
        onChange(parseCommaList(e.target.value));
      }}
    />
  );
};
